import JobZImage from "../../../../common/jobz-img";
import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { setMenuActive } from "../../../../../globals/constants";
import { candidate, canRoute } from "../../../../../globals/route-names";
import { API_URL } from "../../../../../config";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import axiosInstance from "../../../../../axiosInstance";

const colors = [
    "#E63946", // red
    "#457B9D", // blue-gray
    "#2A9D8F", // teal
    "#F4A261", // orange
    "#264653", // deep teal
    "#8E44AD", // purple
    "#D7263D", // crimson
    "#3A86FF", // vivid blue
    "#06D6A0", // mint green
    "#FFBE0B", // yellow
    "#8338EC", // violet
    "#FF006E", // pink
    "#118AB2", // bright blue
    "#073B4C", // dark navy
    "#F77F00", // deep orange
    "#38B000", // green
    "#7209B7", // purple
    "#FF7F50", // coral
    "#008080", // classic teal
];

function getRandomColor(seed) {
    const index = seed.charCodeAt(0) % colors.length;
    return colors[index];
}


function CanSidebarSection() {
    const { t } = useTranslation();
    const currentpath = useLocation().pathname;
    const [user, setUser] = useState(null);
    const [imgError, setImgError] = useState(false);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await axiosInstance.get(`${API_URL}/candidate-profile`, {
                });
                setUser(response.data.data);
            } catch (error) {
                console.error("Error fetching profile:", error.response?.data || error.message);
            }
        };
        fetchProfile();
    }, []);

    // width: 128px;
    // height: 128px;
    // overflow: hidden;
    // border-radius: 10px;
    // top: 30px;
    // position: relative;
    // Handle profile photo upload
    const handleProfilePhotoChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("profilePhoto", file);

        try {
            const response = await axiosInstance.post(
                `${API_URL}/upload-profile-photo`,
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" }
                }
            );

            // Update UI with new photo
            if (response.data.status === 200) {
                toast.success(response.data.message);
                setUser((prev) => ({
                    ...prev,
                    photo_url: response.data.data.profile_photo
                }));
                setImgError(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1500)
            } else {
                console.error("Upload failed:", response.data.message);
            }
        } catch (error) {
            console.error("Error uploading photo:", error.response?.data || error.message);
        }
    };

    const getInitials = () => {
        if (!user || !user.first_name || !user.last_name) return "";
        return `${user.first_name[0]}`.toUpperCase();
    };

    const getAvatarColor = () => {
        if (!user || !user.first_name) return colors[0];
        return getRandomColor(user.first_name[0].toUpperCase());
    };

    return (
        <>
            {user?.photo_url && !imgError ? (
                <div className="twm-candidate-profile-pic">
                    <img
                        src={user.photo_url}
                        alt="Profile"
                        className="w-[150px] h-[150px] rounded-full object-cover"
                        onError={() => setImgError(true)}
                    />
                    <div className="upload-btn-wrapper">
                        <div id="upload-image-grid" />
                        <button className="site-button button-sm">Upload Photo</button>
                        <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            onChange={handleProfilePhotoChange}
                        />
                    </div>
                </div>
            ) : (
                <div className="twm-candidate-profile-pic">
                    <div
                        style={{
                            color: '#fff',
                            fontSize: '90px',
                            borderRadius: ' 10px',
                            marginBottom: '10px',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "500",
                            backgroundColor: getAvatarColor()
                        }}
                    >
                        {getInitials()}
                    </div>
                    <div style={{ marginTop: '10px' }} className="upload-btn-wrapper">
                        <div id="upload-image-grid" />
                        <button className="site-button button-sm">Upload Photo</button>
                        <input
                            type="file"
                            accept=".jpg, .jpeg, .png"
                            onChange={handleProfilePhotoChange}
                        />
                    </div>
                </div>
            )}

            <div className="twm-mid-content text-center">
                <h4>{user ? `${user.first_name} ${user.last_name}` : " "}</h4>
                <p>{user?.email || " "}</p>
            </div>

            <div className="twm-nav-list-1">
                <ul>
                    <li className={setMenuActive(currentpath, canRoute(candidate.DASHBOARD))}>
                        <NavLink to={canRoute(candidate.DASHBOARD)}><i className="fa fa-tachometer-alt" />
                            {t("Dashboard")}
                        </NavLink>
                    </li>
                    <li className={setMenuActive(currentpath, canRoute(candidate.PROFILE))}>
                        <NavLink to={canRoute(candidate.PROFILE)}><i className="fa fa-user" />
                            {t("My Profile")}
                        </NavLink>
                    </li>
                    <li className={setMenuActive(currentpath, canRoute(candidate.ADDLOOP))}>
                        <NavLink to={canRoute(candidate.ADDLOOP)}><i className="fa fa-envelope" />
                            {t("Add Loop")}
                        </NavLink>
                    </li>
                    <li className={setMenuActive(currentpath, canRoute(candidate.MYLOOP))}>
                        <NavLink to={canRoute(candidate.MYLOOP)}><i className="fa fa-briefcase-medical" />
                            {t("My Loops")}
                        </NavLink>
                    </li>
                    {/* <FontAwesomeIcon icon="fa-solid fa-rotate-reverse" /> */}
                    <li className={setMenuActive(currentpath, canRoute(candidate.APPLIED_JOBS))}>
                        <NavLink to={canRoute(candidate.APPLIED_JOBS)}><i className="fa fa-suitcase" />
                            {t("Applied Jobs")}
                        </NavLink>
                    </li>
                    <li className={setMenuActive(currentpath, canRoute(candidate.JOBS_LIST))}>
                        <NavLink to={canRoute(candidate.JOBS_LIST)}><i className="fa fa-users" />
                            {t("Jobs Finder")}
                        </NavLink>
                    </li>
                    {/* <li className={setMenuActive(currentpath, canRoute(candidate.RESUME))}>
                        <NavLink to={canRoute(candidate.RESUME)}><i className="fa fa-receipt" />
                            My Resume
                        </NavLink>
                    </li> */}
                    {/* <li className={setMenuActive(currentpath, canRoute(candidate.SAVED_JOBS))}>
                        <NavLink to={canRoute(candidate.SAVED_JOBS)}><i className="fa fa-file-download" />
                            Saved Jobs
                        </NavLink>
                    </li> */}
                    <li className={setMenuActive(currentpath, canRoute(candidate.CV_MANAGER))}>
                        <NavLink to={canRoute(candidate.CV_MANAGER)}><i className="fa fa-paperclip" />
                            {t("CV Checker")}
                        </NavLink>
                    </li>
                    <li className={setMenuActive(currentpath, canRoute(candidate.PAYMENTS))}>
                        <NavLink to={canRoute(candidate.PAYMENTS)}><i className="fa fa-credit-card" />
                            {t("Payments")}
                        </NavLink>
                    </li>
                    {/* <li className={setMenuActive(currentpath, canRoute(candidate.ALERTS))}>
                        <NavLink to={canRoute(candidate.ALERTS)}><i className="fa fa-bell" />
                            Job Alerts
                        </NavLink>
                    </li> */}
                    <li className={setMenuActive(currentpath, canRoute(candidate.CHANGE_PASSWORD))}>
                        <NavLink to={canRoute(candidate.CHANGE_PASSWORD)}><i className="fa fa-fingerprint" />
                            {t("Change Password")}
                        </NavLink>
                    </li>
                    {/* <li className={setMenuActive(currentpath, canRoute(candidate.CHAT))}>
                        <NavLink to={canRoute(candidate.CHAT)}><i className="fa fa-comments" />
                            Chat
                        </NavLink>
                    </li> */}
                    <li>
                        <a href="/" data-bs-toggle="modal" data-bs-target="#logout-dash-profile">
                            <i className="fa fa-share-square" />
                            <span className="admin-nav-text">{t("Logout")}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default CanSidebarSection;